import type { refundApi } from 'app/src/services/welfareportal'

export const RefundExternalKeysFilter = (addKey: refundApi.AdditionalKey, refund: refundApi.Refund) => {
  if (addKey.tag != 'rimborso') return false
  else {
    if (!addKey.filter) return true
    else {
      if (!refund) return false
      else {
        const equalTokenized = addKey.filter.split('=')
        if (equalTokenized.length !== 2) return false

        const rightComparingValue = equalTokenized[1]

        const objectNavigationFields = equalTokenized[0].split('.')
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let value: any = refund
        objectNavigationFields.forEach((k) => {
          value = value[k]
        })
        if (typeof value === 'string') value = `'${value}'`

        return value === rightComparingValue
      }
    }
  }
}
